import { useEffect, useRef, useState } from 'react';

// Measures a DOM element's rendered width via ResizeObserver, so layout decisions (like
// how many legend items fit per row) can respond to the chart's actual available space
// instead of the whole window's width, which is wrong once sidebars/columns are involved.
export default function useElementWidth<T extends HTMLElement>() {
    const ref = useRef<T | null>(null);
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const element = ref.current;
        if (!element) return;

        const observer = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (entry) setWidth(entry.contentRect.width);
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, []);

    return [ref, width] as const;
}
